import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import NavbarComp from '../components/NavbarComp';
import { Container } from 'react-bootstrap'

const mapStateToProps = (state) => {
  return {
    baseline: state.baseline,
    auth: state.auth
  }
}


const mapDispatchToProps = dispatch => ({

});

class OnboardingThank extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {

    };

  }

  render() {
    return <Fragment>
      <div className="color-body">
        <NavbarComp bgblue={true} access_token={true} />
        <div className="page-sections">
          <div className='onboarding-confirm-wrap'>
            <Container>
              <div className='onboarding-confirm-contents'>
                <h2 className='main-title-style'>THANK YOU</h2>
                <p>You have completed the registration questions.</p>
                {this.props.auth.user  !== null && !this.props.auth.user.voluntary_test ? <>
                  <h2 className='main-title-style'>SLEEP HEALTH SELF-ASSESSMENT</h2>
                  <p>You now have the option to complete a sleep health self-assessment.</p>
                  <p>On completing this assessment you will receive a personalised report to improve your sleep and energy levels. The assessment will take about 5 minutes.</p>
                  <p>Would you like to do it now?</p>
                  <div className='notnow-yes-btns'>
                    <a href={this.props.auth.baseline ? "/dashboard" : '/alertness'} rel="nofollow"><button className='notnow-btn'>Not Now</button></a>
                    <a href='/self-assessment'><button className='yes-btn' rel="nofollow">Yes</button></a>
                  </div>
                </> :
                  <div className='notnow-yes-btns'>
                   {this.props.auth.baseline ? <a href='/dashboard' rel="nofollow"><button className='notnow-btn'>Dashboard</button></a> :
                    <a href='/alertness' rel="nofollow"><button className='notnow-btn'>Alertness</button></a>}
                  </div>
                }
              </div>
            </Container>
          </div>
        </div>
      </div>
    </Fragment>
  }
}


OnboardingThank.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(OnboardingThank);
